export enum ExperienceStyle {
  EVENTS = 'events',
  INSIDERS = 'insiders',
  SELF_EXPLORE = 'self_explore',
}
